/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { BuilderFormSchemaFactory, FormRootSchema, FormStateSchema } from '@gh/builder-shared';
import { SalesManagementCalculationType } from '@gh/builder-shared-data';
import { FormState } from '@gh/common-shared';
import { FormMode, getControlValue } from '@gh/core-ui';

import { SalesManagementReportFilter } from '../../../resources/lead.model';

@Injectable()
export class SalesManagementReportFilterFormState extends FormState<SalesManagementReportFilter> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  getMonthCodeValue(): string {
    return getControlValue(this.group, 'monthCode');
  }

  getCalculationValue(): SalesManagementCalculationType {
    return getControlValue(this.group, 'calculation');
  }

  getForYearValue(): number {
    return getControlValue(this.group, 'forYear');
  }

  getForMonthValue(): number {
    return getControlValue(this.group, 'forMonth');
  }

  getShowInactiveSalespersonsValue(): boolean {
    return getControlValue(this.group, 'showInactiveSalespersons');
  }

  getShowLeadsContactsValue(): boolean {
    return getControlValue(this.group, 'showLeadsContacts');
  }

  protected buildSchema(_: SalesManagementReportFilter, { root }: FormStateSchema): FormRootSchema {
    return root({
      enabled: true,
      mode: FormMode.EditMode,
      children: {
        monthCode: { required: true },
        forMonth: { visible: false },
        forYear: { visible: false },
        showInactiveSalespersons: void 0,
        calculation: void 0,
        showLeadsContacts: void 0,
      },
    });
  }
}
